import { render, staticRenderFns } from "./DetalharUsoPeriodoFormacaoDialog.vue?vue&type=template&id=7c066a7b&scoped=true"
import script from "./DetalharUsoPeriodoFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoPeriodoFormacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoPeriodoFormacaoDialog.vue?vue&type=style&index=0&id=7c066a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c066a7b",
  null
  
)

export default component.exports